import React from 'react';
import {
  LegsHero,
  HowLegWork,
  LHRIdealForLegs,
  ShavingTimeDivider,
  SectionDivider,
  SEO,
} from '../../components';
import { graphql } from 'gatsby';

function LegsPage() {
  return (
    <main id='legs-page'>
      <LegsHero />
      <ShavingTimeDivider />
      <HowLegWork />
      <LHRIdealForLegs />
    </main>
  );
}

export const Head = ({ data, location }) => {
  const query = data.siteDataJson;
  return (
    <SEO
      location={location}
      origin={query.origin}
      title={`Leg Laser Hair Removal | Milan Laser in ${query.name}, ${query.stateAbbrev}`}
      description='Discover the confidence-boosting benefits of our leg laser hair removal treatments. Ditch the razors and wax strips for good and say hello to beautifully smooth legs. Book your session today!'
    />
  );
};

export const query = graphql`
  {
    siteDataJson {
      name
      stateAbbrev
      origin
    }
  }
`;

export default LegsPage;
